/* GENERATED by libs/styles/scripts/nbx-tokens.mjs from libs/styles/src/tokens/nbx.tokens.json. Do not edit. */
export const NBX_MODES = ['rentals', 'ssr', 'lock', 'home', 'service', 'guest', 'icon'] as const;
export type NbxMode = (typeof NBX_MODES)[number];

export const NBX_SCHEMES = ['light', 'dark'] as const;
export type NbxScheme = (typeof NBX_SCHEMES)[number];

export const NBX_TOKEN_IDS = [
  'border.danger',
  'border.default',
  'border.disabled',
  'border.divider',
  'border.focus',
  'border.focus-input',
  'border.primary',
  'border.secondary',
  'border.strong',
  'border.success',
  'border.warning',
  'breakpoints',
  'button.action.bg',
  'button.action.bg-disabled',
  'button.action.bg-hover',
  'button.action.bg-pressed',
  'button.action.fg',
  'button.action.fg-disabled',
  'button.action.fg-hover',
  'button.base.gap',
  'button.base.padding-x',
  'button.base.padding-y',
  'button.base.radius',
  'button.ghost.bg',
  'button.ghost.bg-disabled',
  'button.ghost.bg-hover',
  'button.ghost.bg-pressed',
  'button.ghost.border',
  'button.ghost.fg',
  'button.ghost.fg-disabled',
  'button.ghost.fg-text-icon',
  'button.primary.bg',
  'button.primary.bg-disabled',
  'button.primary.bg-hover',
  'button.primary.bg-pressed',
  'button.primary.fg',
  'button.primary.fg-disabled',
  'button.secondary.bg',
  'button.secondary.bg-disabled',
  'button.secondary.bg-hover',
  'button.secondary.bg-pressed',
  'button.secondary.fg',
  'button.secondary.fg-disabled',
  'button.status.danger.bg',
  'button.status.danger.bg-disabled',
  'button.status.danger.bg-hover',
  'button.status.danger.bg-pressed',
  'button.status.danger.fg',
  'button.status.danger.fg-disabled',
  'button.status.success.bg',
  'button.status.success.bg-disabled',
  'button.status.success.bg-hover',
  'button.status.success.bg-pressed',
  'button.status.success.fg',
  'button.status.success.fg-disabled',
  'button.status.warning.bg',
  'button.status.warning.bg-disabled',
  'button.status.warning.bg-hover',
  'button.status.warning.bg-pressed',
  'button.status.warning.fg',
  'button.status.warning.fg-disabled',
  'button.utility.bg',
  'button.utility.bg-disabled',
  'button.utility.bg-hover',
  'button.utility.bg-pressed',
  'button.utility.fg',
  'button.utility.fg-disabled',
  'buttons.btn-secondary-hover',
  'calendar.sync-pending',
  'color.danger.100',
  'color.danger.200',
  'color.danger.300',
  'color.danger.400',
  'color.danger.50',
  'color.danger.500',
  'color.danger.600',
  'color.danger.700',
  'color.danger.800',
  'color.danger.900',
  'color.danger.950',
  'color.guest.100',
  'color.guest.200',
  'color.guest.300',
  'color.guest.400',
  'color.guest.50',
  'color.guest.500',
  'color.guest.600',
  'color.guest.700',
  'color.guest.800',
  'color.guest.900',
  'color.guest.950',
  'color.home.100',
  'color.home.200',
  'color.home.300',
  'color.home.400',
  'color.home.50',
  'color.home.500',
  'color.home.600',
  'color.home.700',
  'color.home.800',
  'color.home.900',
  'color.home.950',
  'color.lock.100',
  'color.lock.200',
  'color.lock.300',
  'color.lock.400',
  'color.lock.50',
  'color.lock.500',
  'color.lock.600',
  'color.lock.700',
  'color.lock.800',
  'color.lock.900',
  'color.lock.950',
  'color.neutral.100',
  'color.neutral.200',
  'color.neutral.300',
  'color.neutral.400',
  'color.neutral.50',
  'color.neutral.500',
  'color.neutral.600',
  'color.neutral.700',
  'color.neutral.800',
  'color.neutral.900',
  'color.neutral.950',
  'color.primary.100',
  'color.primary.200',
  'color.primary.300',
  'color.primary.400',
  'color.primary.50',
  'color.primary.500',
  'color.primary.600',
  'color.primary.700',
  'color.primary.800',
  'color.primary.900',
  'color.primary.950',
  'color.rentals.100',
  'color.rentals.200',
  'color.rentals.300',
  'color.rentals.400',
  'color.rentals.50',
  'color.rentals.500',
  'color.rentals.600',
  'color.rentals.700',
  'color.rentals.800',
  'color.rentals.900',
  'color.rentals.950',
  'color.rentsody.100',
  'color.rentsody.200',
  'color.rentsody.300',
  'color.rentsody.400',
  'color.rentsody.50',
  'color.rentsody.500',
  'color.rentsody.600',
  'color.rentsody.700',
  'color.rentsody.800',
  'color.rentsody.900',
  'color.rentsody.950',
  'color.secondary.100',
  'color.secondary.200',
  'color.secondary.300',
  'color.secondary.400',
  'color.secondary.50',
  'color.secondary.500',
  'color.secondary.600',
  'color.secondary.700',
  'color.secondary.800',
  'color.secondary.900',
  'color.secondary.950',
  'color.ssr-neutral.100',
  'color.ssr-neutral.200',
  'color.ssr-neutral.300',
  'color.ssr-neutral.400',
  'color.ssr-neutral.50',
  'color.ssr-neutral.500',
  'color.ssr-neutral.600',
  'color.ssr-neutral.700',
  'color.ssr-neutral.800',
  'color.ssr-neutral.900',
  'color.ssr-neutral.950',
  'color.ssr.100',
  'color.ssr.200',
  'color.ssr.300',
  'color.ssr.400',
  'color.ssr.50',
  'color.ssr.500',
  'color.ssr.600',
  'color.ssr.700',
  'color.ssr.800',
  'color.ssr.900',
  'color.ssr.950',
  'color.success.100',
  'color.success.200',
  'color.success.300',
  'color.success.400',
  'color.success.50',
  'color.success.500',
  'color.success.600',
  'color.success.700',
  'color.success.800',
  'color.success.900',
  'color.success.950',
  'color.warning.100',
  'color.warning.200',
  'color.warning.300',
  'color.warning.400',
  'color.warning.50',
  'color.warning.500',
  'color.warning.600',
  'color.warning.700',
  'color.warning.800',
  'color.warning.900',
  'color.warning.950',
  'color.white',
  'control-size.base',
  'control-size.lg',
  'control-size.md',
  'control-size.sm',
  'focus.ring',
  'focus.ring-offset',
  'font-size.2xl',
  'font-size.3xl',
  'font-size.4xl',
  'font-size.5xl',
  'font-size.xl',
  'font.family-brand-base',
  'font.family.base',
  'font.weight.bold',
  'font.weight.normal',
  'font.weight.semibold',
  'heading-3-line-height',
  'heading-3-size',
  'hero-img',
  'horizontal-padding',
  'icon-size.base',
  'icon-size.lg',
  'icon-size.md',
  'icon-size.xl',
  'input.base.gap',
  'input.base.padding-x',
  'input.base.padding-y',
  'input.base.radius',
  'interactive.danger.base',
  'interactive.danger.hover',
  'interactive.danger.pressed',
  'interactive.neutral.base',
  'interactive.neutral.hover',
  'interactive.neutral.subtle',
  'interactive.neutral.subtle-focus',
  'interactive.neutral.subtle-hover',
  'interactive.primary.base',
  'interactive.primary.hover',
  'interactive.primary.pressed',
  'interactive.primary.subtle',
  'interactive.primary.subtle-pressed',
  'interactive.secondary.base',
  'interactive.secondary.hover',
  'interactive.secondary.mid',
  'interactive.secondary.pressed',
  'interactive.secondary.subtle',
  'interactive.secondary.subtle-hover',
  'interactive.secondary.subtle-pressed',
  'interactive.success.base',
  'interactive.success.hover',
  'interactive.success.pressed',
  'interactive.warning.base',
  'interactive.warning.hover',
  'interactive.warning.pressed',
  'layout.page-padding.desktop',
  'layout.page-padding.mobile',
  'layout.page-padding.tablet',
  'line-height.3xl',
  'line-height.4xl',
  'line-height.5xl',
  'line-height.normal',
  'list-button.base.gap',
  'list-button.base.icon-size',
  'list-button.base.padding-x',
  'list-button.base.padding-y',
  'list-button.base.radius',
  'list-button.base.texts-gap',
  'list-button.item.bg',
  'list-button.item.bg-disabled',
  'list-button.item.bg-hover',
  'list-button.item.bg-hover-description',
  'list-button.item.fg',
  'list-button.item.fg-description',
  'list-button.item.fg-disabled',
  'list-button.item.icon-bg',
  'list-button.item.icon-bg-disabled',
  'list-button.item.icon-bg-hover',
  'list-button.item.icon-fg',
  'list-button.item.icon-fg-disabled',
  'logo',
  'main.100',
  'main.80',
  'messages.base.gap',
  'messages.base.padding-x',
  'messages.base.padding-y',
  'messages.base.radius',
  'messages.danger.bg',
  'messages.danger.border',
  'messages.danger.fg',
  'messages.info.bg',
  'messages.info.border',
  'messages.info.fg',
  'messages.success.bg',
  'messages.success.border',
  'messages.success.fg',
  'messages.warning.bg',
  'messages.warning.border',
  'messages.warning.fg',
  'modal.base.gap',
  'modal.base.padding-x',
  'modal.base.padding-y',
  'modal.base.radius',
  'neutral.white',
  'pagination.bg-default',
  'pagination.bg-disabled',
  'pagination.bg-hover',
  'pagination.bg-pressed',
  'pagination.fg-default',
  'pagination.fg-disabled',
  'pagination.fg-hover',
  'primary',
  'radius.16',
  'radius.24',
  'radius.4',
  'radius.8',
  'radius.full',
  'select-button.base.gap',
  'select-button.base.padding-x',
  'select-button.base.padding-y',
  'select-button.base.radius',
  'select-button.item.bg',
  'select-button.item.bg-disabled',
  'select-button.item.bg-unselected',
  'select-button.item.fg',
  'select-button.item.fg-disabled',
  'select-button.item.fg-selected',
  'select-button.track-off',
  'selection-card.base.gap',
  'selection-card.base.padding-x',
  'selection-card.base.padding-y',
  'selection-card.base.radius',
  'selection-card.item.bg-active',
  'selection-card.item.bg-default',
  'selection-card.item.border',
  'selection-card.item.fg-active',
  'selection-card.item.fg-default',
  'settings.footer-height',
  'shadow.card',
  'shadow.card-layered',
  'shadow.lg',
  'shadow.md',
  'shadow.md-up',
  'shadow.message',
  'shadow.overlay-lg',
  'shadow.overlay-md',
  'shadow.overlay-sm',
  'shadow.p-shadow-2',
  'shadow.pagination',
  'shadow.rental-card',
  'shadow.sm',
  'sidebar.item.bg-active',
  'sidebar.item.bg-default',
  'sidebar.item.bg-hover',
  'sidebar.item.fg-active',
  'sidebar.item.fg-default',
  'space-16',
  'space-24',
  'space-4',
  'space-8',
  'spacing.16',
  'spacing.24',
  'spacing.32',
  'spacing.4',
  'spacing.40',
  'spacing.48',
  'spacing.56',
  'spacing.64',
  'spacing.8',
  'spacing.md',
  'spacing.space-16',
  'spacing.space-24',
  'spacing.space-32',
  'spacing.space-4',
  'spacing.space-8',
  'states.active.bg',
  'states.active.fg',
  'states.danger.bg',
  'states.danger.border',
  'states.danger.fg',
  'states.info.bg',
  'states.info.border',
  'states.info.fg',
  'states.success.bg',
  'states.success.border',
  'states.success.fg',
  'states.warning.bg',
  'states.warning.border',
  'states.warning.fg',
  'success.100',
  'surface.bg-white',
  'surface.brand-soft',
  'surface.canvas',
  'surface.dark',
  'surface.disabled',
  'surface.ground',
  'surface.modal',
  'surface.overlay',
  'surface.overlay-modal',
  'surface.raised',
  'table.bookings-min-width',
  'table.header-bg',
  'table.header-height',
  'table.row-height',
  'tablist.base.padding-x',
  'tablist.base.padding-y',
  'tablist.base.radius',
  'tablist.bg',
  'tag.base.gap',
  'tag.base.padding-x',
  'tag.base.padding-y',
  'tag.base.radius',
  'tag.brand.solid.bg',
  'tag.brand.solid.fg',
  'tag.status.danger.bg',
  'tag.status.danger.fg',
  'tag.status.info.bg',
  'tag.status.info.fg',
  'tag.status.success.bg',
  'tag.status.success.fg',
  'tag.status.warning.bg',
  'tag.status.warning.fg',
  'text',
  'text-style.badge.label-large.font-family',
  'text-style.badge.label-large.font-size',
  'text-style.badge.label-large.font-weight',
  'text-style.badge.label-large.letter-spacing',
  'text-style.badge.label-large.line-height',
  'text-style.badge.label.font-family',
  'text-style.badge.label.font-size',
  'text-style.badge.label.font-weight',
  'text-style.badge.label.letter-spacing',
  'text-style.badge.label.line-height',
  'text-style.body.base-bold.font-family',
  'text-style.body.base-bold.font-size',
  'text-style.body.base-bold.font-weight',
  'text-style.body.base-bold.letter-spacing',
  'text-style.body.base-bold.line-height',
  'text-style.body.base-semi.font-family',
  'text-style.body.base-semi.font-size',
  'text-style.body.base-semi.font-weight',
  'text-style.body.base-semi.letter-spacing',
  'text-style.body.base-semi.line-height',
  'text-style.body.base.font-family',
  'text-style.body.base.font-size',
  'text-style.body.base.font-weight',
  'text-style.body.base.letter-spacing',
  'text-style.body.base.line-height',
  'text-style.body.caption.font-family',
  'text-style.body.caption.font-size',
  'text-style.body.caption.font-weight',
  'text-style.body.caption.letter-spacing',
  'text-style.body.caption.line-height',
  'text-style.body.l.md-bold.font-family',
  'text-style.body.l.md-bold.font-size',
  'text-style.body.l.md-bold.font-weight',
  'text-style.body.l.md-bold.letter-spacing',
  'text-style.body.l.md-bold.line-height',
  'text-style.body.large-semi.font-family',
  'text-style.body.large-semi.font-size',
  'text-style.body.large-semi.font-weight',
  'text-style.body.large-semi.letter-spacing',
  'text-style.body.large-semi.line-height',
  'text-style.body.m.bold.font-family',
  'text-style.body.m.bold.font-size',
  'text-style.body.m.bold.font-weight',
  'text-style.body.m.bold.letter-spacing',
  'text-style.body.m.bold.line-height',
  'text-style.body.m.regular.font-family',
  'text-style.body.m.regular.font-size',
  'text-style.body.m.regular.font-weight',
  'text-style.body.m.regular.letter-spacing',
  'text-style.body.m.regular.line-height',
  'text-style.body.m.semibold.font-family',
  'text-style.body.m.semibold.font-size',
  'text-style.body.m.semibold.font-weight',
  'text-style.body.m.semibold.letter-spacing',
  'text-style.body.m.semibold.line-height',
  'text-style.body.s.s-regular.font-family',
  'text-style.body.s.s-regular.font-size',
  'text-style.body.s.s-regular.font-weight',
  'text-style.body.s.s-regular.letter-spacing',
  'text-style.body.s.s-regular.line-height',
  'text-style.body.s.s-semibold.font-family',
  'text-style.body.s.s-semibold.font-size',
  'text-style.body.s.s-semibold.font-weight',
  'text-style.body.s.s-semibold.letter-spacing',
  'text-style.body.s.s-semibold.line-height',
  'text-style.body.small-bold.font-family',
  'text-style.body.small-bold.font-size',
  'text-style.body.small-bold.font-weight',
  'text-style.body.small-bold.letter-spacing',
  'text-style.body.small-bold.line-height',
  'text-style.body.small-semi.font-family',
  'text-style.body.small-semi.font-size',
  'text-style.body.small-semi.font-weight',
  'text-style.body.small-semi.letter-spacing',
  'text-style.body.small-semi.line-height',
  'text-style.body.small.font-family',
  'text-style.body.small.font-size',
  'text-style.body.small.font-weight',
  'text-style.body.small.letter-spacing',
  'text-style.body.small.line-height',
  'text-style.button.label-base.font-family',
  'text-style.button.label-base.font-size',
  'text-style.button.label-base.font-weight',
  'text-style.button.label-base.letter-spacing',
  'text-style.button.label-base.line-height',
  'text-style.button.label-small-bold.font-family',
  'text-style.button.label-small-bold.font-size',
  'text-style.button.label-small-bold.font-weight',
  'text-style.button.label-small-bold.letter-spacing',
  'text-style.button.label-small-bold.line-height',
  'text-style.heading.1.font-family',
  'text-style.heading.1.font-size',
  'text-style.heading.1.font-weight',
  'text-style.heading.1.letter-spacing',
  'text-style.heading.1.line-height',
  'text-style.heading.3.font-family',
  'text-style.heading.3.font-size',
  'text-style.heading.3.font-weight',
  'text-style.heading.3.letter-spacing',
  'text-style.heading.3.line-height',
  'text-style.heading.4.variant-bold-18.font-family',
  'text-style.heading.4.variant-bold-18.font-size',
  'text-style.heading.4.variant-bold-18.font-weight',
  'text-style.heading.4.variant-bold-18.letter-spacing',
  'text-style.heading.4.variant-bold-18.line-height',
  'text-style.heading.4.variant-semibold-16.font-family',
  'text-style.heading.4.variant-semibold-16.font-size',
  'text-style.heading.4.variant-semibold-16.font-weight',
  'text-style.heading.4.variant-semibold-16.letter-spacing',
  'text-style.heading.4.variant-semibold-16.line-height',
  'text.danger',
  'text.disabled',
  'text.line-height.2xl',
  'text.line-height.base',
  'text.line-height.sm',
  'text.line-height.xs',
  'text.link',
  'text.link-disabled',
  'text.link-hover',
  'text.muted',
  'text.on-color',
  'text.primary',
  'text.secondary',
  'text.size.base',
  'text.size.lg',
  'text.size.sm',
  'text.size.xs',
  'text.success',
  'text.tertiary',
  'text.warning',
  'tooltip.bg-default',
  'tooltip.fg-default',
  'transition.fast',
  'transition.normal',
  'vertical-padding',
] as const;
export type NbxTokenId = (typeof NBX_TOKEN_IDS)[number];

/** CSS custom property name of a token. */
export function nbxVarName(id: NbxTokenId): string {
  return `--nbx-${id.replace(/\./g, '-')}`;
}

/** `var(--nbx-…)` reference to a token, the only form presets and styles may use. */
export function nbxVar(id: NbxTokenId): string {
  return `var(${nbxVarName(id)})`;
}
